import { render } from "./QuickView.vue?vue&type=template&id=dadd9548"
import script from "./QuickView.vue?vue&type=script&lang=js"
export * from "./QuickView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__